import { RecommendationItem } from '../RecommendationFeed/api';
import { request } from '@sharpana/auth/api_client/allauth';

interface BookmarkedItemsResponse {
  items: RecommendationItem[];
  total: number;
  total_pages: number;
  current_page: number;
  error?: string;
}

export const getBookmarkCount = async (): Promise<number> => {
  try {
    const response = await request('GET', '/api/bookmarks/count/', undefined, undefined);
    return response.count || 0;
  } catch (error) {
    console.error('Error fetching bookmark count:', error);
    return 0;
  }
};

export const getBookmarkedItems = async (page: number, pageSize: number): Promise<BookmarkedItemsResponse> => {
  try {
    const response = await request('GET', `/api/bookmarks/?page=${page}&page_size=${pageSize}`, undefined, undefined);
    return response;
  } catch (error) {
    console.error('Error fetching bookmarked items:', error);
    return {
      items: [],
      total: 0,
      total_pages: 0,
      current_page: page,
      error: error instanceof Error ? error.message : 'Failed to fetch bookmarked items',
    };
  }
};
